import PropTypes from 'prop-types'

import { brandPropType } from '../../brand-curation-tasks/prop-types'

const menuPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  brand: brandPropType.isRequired,
  url: PropTypes.string,
  isFake: PropTypes.bool,
  dishCount: PropTypes.number,
})

export default menuPropType
